import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';

export const GetColorFoodie = createAsyncThunk('employeeFoodie/getColorFoodie', async () => {
    const response = await apiInstance
        .get('foodie-service/v1/colors/get')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetSecurityLogs = createAsyncThunk(
    'employeeFoodie/getSecurityLogs',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`foodie-service/v1/logs/user/${userId}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const GetFirstFoodieSetting = createAsyncThunk('employeeFoodie/getFirstFoodieSetting', async () => {
    const response = await apiInstance
        .get('foodie-service/v1/settings/get')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllFoodieDepartment = createAsyncThunk('employeeFoodie/getAllFoodieDepartment', async () => {
    const response = await apiInstance
        .get('foodie-service/v1/departments/get-all')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetFoodieDepartmentById = createAsyncThunk('employeeFoodie/getFoodieDepartmentById', async (params) => {
    const response = await apiInstance.get('foodie-service/v1/departments/by-id/'+params).then((response) => {
        return response;
    })
        .catch((error) => {return error.response; });
    const { data, status } = response;
    return { data, status };
});
export const GetAllFoodieDevices = createAsyncThunk('employeeFoodie/getAllFoodieDevices', async () => {
    const response = await apiInstance
        .get('foodie-service/v1/devices/get-all')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetFoodieRecordById = createAsyncThunk(
    'employeeFoodie/getFoodieRecordById',
    async (id, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`foodie-service/v1/${id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const CreatesFoodieRecord = createAsyncThunk('employeeFoodie/createsFoodieRecord', async (params) => {
    const response = await apiInstance
        .post('foodie-service/v1/create')
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreatesFoodieDepartment = createAsyncThunk('employeeFoodie/createsFoodieDepartment', async (params) => {
    const response = await apiInstance
        .post('foodie-service/v1/departments/create', params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const AddDeviceToListFoodie = createAsyncThunk(
    'employeeFoodie/addDeviceToListFoodie',
    async (deviceId, { dispatch, getState }) => {
        const result = await apiInstance
            .post(`foodie-service/v1/devices/create/by-device-id/${deviceId}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
export const UpdateFoodieDepartment = createAsyncThunk('employeeFoodie/updateFoodieDepartment', async (params) => {
    const response = await apiInstance
        .put('foodie-service/v1/departments/update', params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
// change the time or checkbox payroll
export const UpdateFoodieSettingColor = createAsyncThunk(
    'employeeFoodie/updateFoodieSettingColor',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put('foodie-service/v1/colors/update', params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const RemoveDeviceFoodie = createAsyncThunk(
    'employeeFoodie/removeDeviceFoodie',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post('foodie-service/v1/devices/delete-list', params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const UpdateSettingsRestrictions = createAsyncThunk(
    'employeeFoodie/updateSettingsRestrictions',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put('foodie-service/v1/settings/update', params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const UpdateFoodieRecordById = createAsyncThunk(
    'employeeFoodie/updateFoodieRecordById',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put('foodie-service/v1/update', params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
